import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Radio, Col } from 'antd';
// 参数
const RadioGroup = Radio.Group;

class RadioList extends Component {
	onChange = (e) => {
		const { onChange } = this.props;
		onChange && onChange(e.target.value)
	}

	render () {
		const { errType } = this.props;
		return (
			<RadioGroup 
				onChange={this.onChange}
				value={errType}
				className="signRadio">
				<Col span={18}>
					<div className="signErr">
						<Radio value="2">错图</Radio>
						<Radio value="3">歧义</Radio>
						<Radio value="4">相似</Radio>
						<Radio value="5">丑图</Radio>
					</div>
				</Col>
				<Col span={5} className="signSuccess">
					<Radio value="1">合适</Radio>
				</Col>
			</RadioGroup>
		)
	}
}

const mapStateToProps = state => {
	return {}
}

const mapDispatchToProps = dispatch => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(RadioList)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/common/radioGroup.js